<aboca-apoteca-desktop-fake-container *ngIf="wrapperVisible">
  <aboca-desktop-layout-content></aboca-desktop-layout-content>
</aboca-apoteca-desktop-fake-container>
<aboca-desktop-layout-content *ngIf="!wrapperVisible"></aboca-desktop-layout-content>
<bitf-loader></bitf-loader>